import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

const NeedHelpButton = () => {
  return (
    <Link to="/support-help">
      <div className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40 group">
        <button className="bg-indigo-600 hover:bg-indigo-700 text-white rounded-full p-3 shadow-lg flex items-center gap-2 transition-all group-hover:pr-4">
          <HelpCircle className="h-5 w-5" />
          <span className="hidden group-hover:inline-block text-sm font-medium whitespace-nowrap">
            Need help?
          </span>
        </button>
      </div>
    </Link>
  );
};

export default NeedHelpButton;
